// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2lFOg","messages":"Chat_messages__1zL4T","dateDivider":"Chat_dateDivider__zxzJ9"};